import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import Grid from "@mui/material/Grid";

import FormBloc from "components/form/FormBloc";
import ScoringInfoDrawer from "components/Product/ScoringInfoDrawer";

import ProductGlobalScoring from "./components/ProductGlobalScoring";
import ScoreGraph from "./components/ScoreGraph";
import ScoringSummary from "./components/ScoringSummary";

ProductScoring.propTypes = {
    scoring: PropTypes.object,
    descriptionScore: PropTypes.object,
    validationScore: PropTypes.number,
    validated: PropTypes.bool
};

function ProductScoring({scoring, descriptionScore, validationScore, validated = true}) {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    if (!scoring && validated) {
        return null;
    }

    // The scoring is computed independently of the product's validation status,
    // but a non-validated product's data isn't reliable enough to show — force NA.
    const isScoreAvailable = validated && !!scoring;

    // attractiveness.max = 30, we must convert to 100
    const attractivenessScore = isScoreAvailable ? (scoring.attractiveness.points * 100) / scoring.attractiveness.max : null;

    const onOpenDrawer = isScoreAvailable ? () => setIsDrawerOpen(true) : undefined;

    return (
        <FormBloc
            titleId='retailer.product.scoring.drawer.title'
            rightElement={<ProductGlobalScoring score={isScoreAvailable ? scoring.score : null} validated={validated} onOpenDrawer={onOpenDrawer} />}
        >
            <Grid container rowSpacing={3}>
                <Grid item xs={12}>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <ScoreGraph
                            score={isScoreAvailable ? (descriptionScore?.displayScore ?? null) : null}
                            title={<FormattedMessage id={'retailer.product.scoring.form.graph.description.title'} />}
                            tooltip={'retailer.product.scoring.form.graph.description.tooltip'}
                        />
                        <ScoreGraph
                            score={isScoreAvailable ? (scoring.attractiveness.imageCount.visualScore ?? null) : null}
                            title={<FormattedMessage id={'retailer.product.scoring.form.graph.visual.title'} />}
                            tooltip={'retailer.product.scoring.form.graph.visual.tooltip'}
                        />
                        <ScoreGraph
                            score={isScoreAvailable ? validationScore : null}
                            title={<FormattedMessage id={'retailer.product.scoring.form.graph.completeness.title'} />}
                            tooltip={'retailer.product.scoring.form.graph.completeness.tooltip'}
                        />
                    </div>
                </Grid>
                <ScoringSummary
                    scoring={isScoreAvailable ? scoring : null}
                    demandScore={isScoreAvailable ? scoring.searchImpressions : null}
                    attractivenessScore={attractivenessScore}
                    potentialImprovementScore={isScoreAvailable ? scoring.potentialScore : null}
                    onOpenDrawer={onOpenDrawer}
                />
            </Grid>
            {isScoreAvailable && (
                <ScoringInfoDrawer
                    open={isDrawerOpen}
                    onClose={() => setIsDrawerOpen(false)}
                    scoring={scoring}
                    scoringDate={scoring.computedAt}
                />
            )}
        </FormBloc>
    );
}

export default ProductScoring;
